import { Fragment } from 'react';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { Box, ListItem } from '@mui/material';
import { useNavigate } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';

interface TeamsListProps {
  search?: string;
  selectedUser?: string | null;
  teams: any[],
  teamUid:any,
  loading:any
}

// const AvatarImage = styled('img')({
//   width: '40px',
//   height: '40px'
// });

// ==============================|| CHAT - USER LIST ||============================== //

export default function TeamsList({ teams,teamUid,loading}: TeamsListProps) {
  // const theme = useTheme();
  const navigate = useNavigate();
  // Use loading prop if provided, otherwise fallback to teams undefined/null
  const isLoading = loading === true || teams === undefined || teams === null; // Loader if teams not loaded
  return (
    <Box sx={{ position: 'relative' }}>
      {/* Loader overlay for teams list */}
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            bgcolor: 'rgba(255,255,255,0.6)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 1, textAlign: 'center' }}>Loading Processes...</Typography>
            <Stack alignItems="center">
              <Box><span><CircularProgress size={32} color="primary" thickness={4} /></span></Box>
            </Stack>
          </Box>
        </Box>
      )}
      <List component="nav">
        <Fragment>
          {teams.length == 0 && (
            <ListItem sx={{ pl: 1, borderRadius: 0, '&:hover': { borderRadius: 1 } }} >
              <ListItemText
                primary={
                  <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                    <Typography color="text.secondary" variant="caption">
                      Processes list is empty!
                    </Typography>
                  </Stack>
                }
              />
            </ListItem>
          )}
          {
            teams.map(team => {
              return (
                  <ListItemButton
                    sx={{ pl: 1, borderRadius: 0, '&:hover': { borderRadius: 1 } }}
                    onClick={() => {
                      navigate(`/teams/modify/${team?.uid}`);
                    }}
                    selected={(teamUid && teamUid == team?.uid) ? true : false}
                    
                  >
               
                    <ListItemText
                      primary={
                        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              color="text.primary"
                              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                            >
                              {team?.name}
                            </Typography>
                            <Typography  variant="caption" textOverflow={'ellipsis'} sx={{color:"text.dark",
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 1,
                            }}>
                              {team?.client?.name || 'No Client Mapped'}
                            </Typography>
                          </Box>
                          
                        </Stack>
                      }
                    />
                  </ListItemButton>
              )
            })
          }
          <Divider />
        </Fragment>
      </List>
    </Box>
  );
}
